var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "chatbot-plans" }, [
    _c("div", { staticClass: "d-flex" }, [
      _c(
        "div",
        { staticClass: "side-menubar-wrapper" },
        [_c("SideMenuBar")],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "body" }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(_vm._s(_vm.$t("message.planManagement"))),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content" }, [
          _c("div", { staticClass: "plan-statistic" }, [
            _c(
              "div",
              { staticClass: "statistic-item" },
              [
                _c("a-progress", {
                  attrs: {
                    type: "circle",
                    percent: _vm.getChatbotSessionStatus(),
                    strokeWidth: 10,
                  },
                }),
                _vm._v(" "),
                _c("div", { staticClass: "statistic-content" }, [
                  _c("div", { staticClass: "statistic-title" }, [
                    _vm._v(_vm._s(_vm.$t("message.usedSessionCount"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "statistic-value" }, [
                    _vm._v(_vm._s(_vm.conversationStatistics.chatbotUsage)),
                  ]),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "statistic-item" }, [
              _c("div", { staticClass: "statistic-content" }, [
                _c("div", { staticClass: "statistic-title" }, [
                  _vm._v(_vm._s(_vm.$t("message.maxSessionCount"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "statistic-value" }, [
                  _vm._v(_vm._s(_vm.features.totalSessionCount)),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "statistic-item" }, [
              _c("div", { staticClass: "statistic-content" }, [
                _c("div", { staticClass: "statistic-title" }, [
                  _vm._v(_vm._s(_vm.$t("message.leftSessionCount"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "statistic-value" }, [
                  _vm._v(
                    "\n                                " +
                      _vm._s(
                        _vm.features.totalSessionCount -
                          _vm.conversationStatistics.chatbotUsage
                      ) +
                      "\n                            "
                  ),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }